import React, { useEffect } from "react";
import {
  ArrowLeft,
  Mail,
  Phone,
  MapPin,
  Clock3,
  Send,
  ShieldCheck,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <div className="bg-[#F6F9FC] text-[#0F172A] overflow-hidden relative">

      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-[400px] bg-gradient-to-b from-[#40E095]/10 via-[#40E095]/5 to-transparent pointer-events-none" />

      <div className="absolute top-40 right-[0px] w-[350px] h-[350px] bg-[#40E095]/10 blur-3xl rounded-full pointer-events-none" />

      <div className="absolute bottom-0 left-[-120px] w-[350px] h-[350px] bg-emerald-200/20 blur-3xl rounded-full pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-6 py-14">

        {/* Back Button */}
        <button
          onClick={() => {
            navigate("/");

            setTimeout(() => {
              window.scrollTo({
                top: 0,
                behavior: "instant",
              });
            }, 0);
          }}
          className="flex items-center gap-2 text-gray-500 hover:text-[#40E095] transition-all duration-300 mb-10"
        >
          <ArrowLeft size={20} />

          <span className="font-medium">
            Back
          </span>
        </button>

        {/* HERO */}
        <div className="relative bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_40px_rgba(0,0,0,0.05)] rounded-[28px] overflow-hidden mb-8">

          <div className="absolute top-0 right-0 w-[180px] h-[180px] bg-[#40E095]/10 blur-3xl rounded-full" />

          <div className="relative p-6 md:p-8">

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">

              {/* LEFT */}
             {/* LEFT */}
<div className="max-w-3xl">

  {/* Heading Row */}
  <div className="flex items-center gap-4">

    <div className="w-14 h-14 flex-shrink-0 rounded-2xl bg-[#40E095]/15 border border-[#40E095]/30 flex items-center justify-center">
      <ShieldCheck
        size={28}
        className="text-[#40E095]"
      />
    </div>

    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-none">
      Contact{" "}
      <span className="text-[#40E095]">
        Us
      </span>
    </h1>

  </div>

  {/* Paragraph */}
  <p className="mt-5 pl-[72px] text-base md:text-lg text-slate-600 leading-7">
    We’re here to help you with support,
    billing, technical assistance, and
    business inquiries.
  </p>

</div>
            </div>
          </div>
        </div>



        {/* TOP CONTACT CARDS */}
       <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">

          {/* CARD 1 */}
          <div className="bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_30px_rgba(0,0,0,0.04)] rounded-[28px] p-6 h-full">

            <div className="w-14 h-14 rounded-2xl bg-[#40E095]/10 flex items-center justify-center text-[#40E095] mb-5">
              <Phone size={24} />
            </div>

            <p className="text-sm text-slate-500 mb-2">
              Customer Care
            </p>

            <h3 className="text-slate-700 leading-7 font-medium">
              +91 6363-900-800
            </h3>

          </div>

          {/* CARD 2 */}
          <div className="bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_30px_rgba(0,0,0,0.04)] rounded-[28px] p-6 h-full">

            <div className="w-14 h-14 rounded-2xl bg-[#40E095]/10 flex items-center justify-center text-[#40E095] mb-5">
              <Mail size={24} />
            </div>

            <p className="text-sm text-slate-500 mb-2">
              Email Address
            </p>

            <h3 className="text-slate-700 leading-7 font-medium">
              support@drivault.com
            </h3>

          </div>

          {/* CARD 3 */}
          <div className="bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_30px_rgba(0,0,0,0.04)] rounded-[28px] p-6 h-full">

            <div className="w-14 h-14 rounded-2xl bg-[#40E095]/10 flex items-center justify-center text-[#40E095] mb-5">
              <MapPin size={24} />
            </div>

            <p className="text-sm text-slate-500 mb-2">
              Office Address
            </p>

            <p className="text-slate-700 leading-7 font-medium">
              4th Floor, Oneness, Sadashivnagar, Belagavi, Karnataka, India 590001
            </p>

          </div>

          {/* CARD 4 */}
          <div className="bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_30px_rgba(0,0,0,0.04)] rounded-[28px] p-6 h-full">

            <div className="w-14 h-14 rounded-2xl bg-[#40E095]/10 flex items-center justify-center text-[#40E095] mb-5">
              <Clock3 size={24} />
            </div>

            <p className="text-sm text-slate-500 mb-2">
              Working Hours
            </p>

            <p className="text-slate-700 leading-7 font-medium">
              Monday - Saturday
              <br />
              9:00 AM — 7:00 PM
            </p>

          </div>

        </div>

        {/* FORM SECTION */}
        {/* <div className="bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_40px_rgba(0,0,0,0.05)] rounded-[32px] p-8 md:p-10">

          <div className="mb-8">

            <h2 className="text-3xl font-bold mb-3">
              Send us a message
            </h2>

            <p className="text-slate-600 leading-7">
              Fill out the form below and our team
              will get back to you shortly.
            </p>

          </div>

          <form className="space-y-6">

            <div className="grid md:grid-cols-2 gap-6">

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Full Name
                </label>

                <input
                  type="text"
                  placeholder="Enter your full name"
                  className="w-full h-14 rounded-2xl border border-slate-300 px-5 outline-none focus:border-[#40E095] bg-white transition-all"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Email Address
                </label>

                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full h-14 rounded-2xl border border-slate-300 px-5 outline-none focus:border-[#40E095] bg-white transition-all"
                />
              </div>

            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Subject
              </label>

              <input
                type="text"
                placeholder="Enter subject"
                className="w-full h-14 rounded-2xl border border-slate-300 px-5 outline-none focus:border-[#40E095] bg-white transition-all"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Message
              </label>

              <textarea
                rows="7"
                placeholder="Write your message here..."
                className="w-full rounded-2xl border border-slate-300 p-5 outline-none focus:border-[#40E095] bg-white transition-all resize-none"
              />
            </div>

            <button
              type="submit"
              className="inline-flex items-center gap-3 bg-[#40E095] hover:bg-[#31cb82] transition-all duration-300 text-[#0F172A] font-semibold px-8 h-14 rounded-2xl shadow-lg hover:shadow-xl"
            >
              <Send size={18} />

              Send Message
            </button>

          </form>

        </div> */}

        {/* FOOTER */}
        {/* <div className="mt-14 pt-6 border-t border-slate-200 text-center text-slate-500 text-sm">
          © 2026 Drivault — Outofbox Cloud Private Limited.
          All rights reserved.
        </div> */}

      </div>
    </div>
  );
};

export default ContactUs;